export default function Loader() {
  return (
    <div
      style={{
        width: '100vw',
        height: '56.25vw',
        maxWidth: '177.78vh',
        maxHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#1a1a1a',
        gap: '2.5vw',
      }}
    >
      {/* rings */}
      {/* <div style={{ position: 'relative', width: '6vw', height: '6vw' }}>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            borderRadius: '50%',
            border: '0.25vw solid transparent',
            borderTopColor: '#008b60',
            borderRightColor: '#008b6044',
            animation: 'ram-spin 1.1s linear infinite',
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: '0.8vw',
            borderRadius: '50%',
            border: '0.25vw solid transparent',
            borderBottomColor: '#c8102e',
            borderLeftColor: '#c8102e44',
            animation: 'ram-spin 1.1s linear infinite reverse',
          }}
        />
        <div
          style={{
            position: 'absolute',
            inset: '1.9vw',
            borderRadius: '50%',
            background: '#008b60',
            animation: 'ram-breathe 1.1s ease-in-out infinite',
          }}
        />
      </div> */}

      {/* plane + trail */}
      {/* <div style={{ position: 'relative', width: '30vw', height: '4.5vw' }}>
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            width: 0,
            height: '0.18vw',
            background: 'linear-gradient(to right, transparent, #008b60)',
            transform: 'translateY(-50%)',
            animation: 'ram-trail 2.2s cubic-bezier(0.4,0,0.6,1) infinite',
          }}
        />
        <div
          style={{
            position: 'absolute',
            top: '50%',
            left: 0,
            transform: 'translateY(-50%)',
            animation: 'ram-fly 2.2s cubic-bezier(0.4,0,0.6,1) infinite',
          }}
        >
          <svg width="3vw" viewBox="0 0 32 24" fill="none">
            <path d="M2 12 L20 4 L30 12 L20 20 Z" fill="#008b60" />
            <path d="M14 12 L22 8 L26 12 L22 16 Z" fill="#c8102e" />
            <path d="M20 12 L32 10 L32 14 Z" fill="#ffffff33" />
            <path d="M10 12 L14 7 L14 17 Z" fill="#008b6099" />
            <circle cx="21" cy="12" r="1.5" fill="#ffffff" />
          </svg>
        </div>
      </div> */}

      {/* dots */}
      <div style={{ display: 'flex', gap: '0.7vw' }}>
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            style={{
              width: '0.7vw',
              height: '0.7vw',
              borderRadius: '50%',
              background: i % 2 === 0 ? '#008b60' : '#c8102e',
              animation: `ram-pulse 1.2s ease-in-out infinite ${i * 0.2}s`,
            }}
          />
        ))}
      </div>

      <span
        style={{
          fontFamily: 'monospace',
          fontSize: '0.85vw',
          letterSpacing: '0.18em',
          color: '#ffffff55',
          textTransform: 'uppercase',
        }}
      >
        chargement
      </span>

      <style>{`
        @keyframes ram-spin { to { transform: rotate(360deg) } }
        @keyframes ram-breathe {
          0%,100% { transform: scale(0.85); background: #008b60 }
          50%      { transform: scale(1.1);  background: #c8102e }
        }
        @keyframes ram-fly {
          0%   { left: 0;     opacity: 0 }
          8%   { opacity: 1 }
          92%  { opacity: 1 }
          100% { left: 27vw;  opacity: 0 }
        }
        @keyframes ram-trail {
          0%   { left: 0;    width: 0 }
          50%  { left: 0;    width: 15vw }
          100% { left: 27vw; width: 0 }
        }
        @keyframes ram-pulse {
          0%,100% { transform: scale(1);   opacity: 0.35 }
          50%     { transform: scale(1.5); opacity: 1 }
        }
      `}</style>
    </div>
  );
}
